import { memo } from "../../../lib/memo";
var getConfig = memo(function (monthTitleLineHeight, monthTitlePaddingTop, monthTitlePaddingBottom, monthTitleMarginBottom, cellWidth, cellHeight, wrapperHeight, monthMarginBottom, maxMonthsToAppendOnScroll, calendarGridRowSpacing) {
  var monthTitleHeight = parseInt(monthTitleLineHeight) + parseInt(monthTitlePaddingTop) + parseInt(monthTitlePaddingBottom);
  return {
    DAY_WIDTH: parseInt(cellWidth),
    DAY_HEIGHT: parseInt(cellHeight),
    MONTH_TITLE_HEIGHT: monthTitleHeight,
    MONTH_TITLE_OFFSET_HEIGHT: monthTitleHeight + parseInt(monthTitleMarginBottom) + 1,
    // + 1px separator line
    WRAPPER_HEIGHT: parseInt(wrapperHeight),
    MONTH_BOTTOM_MARGIN: parseInt(monthMarginBottom),
    MAX_MONTHS_TO_APPEND_ON_SCROLL: parseInt(maxMonthsToAppendOnScroll),
    CALENDAR_GRID_ROW_SPACING: parseInt(calendarGridRowSpacing)
  };
});
export var themeConfig = function themeConfig(t) {
  return getConfig(t.calendarMonthTitleLineHeight, t.calendarMonthTitlePaddingTop, t.calendarMonthTitlePaddingBottom, t.calendarMonthTitleMarginBottom, t.calendarCellWidth, t.calendarCellHeight, t.calendarWrapperHeight, t.calendarMonthMarginBottom, t.calendarMaxMonthsToAppendOnScroll, t.calendarGridRowSpacing);
};